import { RestApiRequest } from "../Models/RestApiRequest";
import { fetchData } from "./BaseService";

export const getUserData = async () => {
  var request: RestApiRequest = {
    url: "/api/dealeradmins/user",
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};

export const getDealersForUser = async () => {
  var request: RestApiRequest = {
    url: "/api/dealeradmins/dealers",
    method: "GET",
  };
  const response = await fetchData(request);
  return response;
};
